var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay",on:{"click":function($event){return _vm.$emit('close')}}},[_c('div',{staticStyle:{"background-color":"#fff","padding":"20px","border-radius":"10px","border":"#0008 solid 1px"},on:{"click":function($event){$event.stopPropagation();}}},[_c('qrcode-stream',{on:{"decode":_vm.onDecode,"init":_vm.onInit}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }